import React from "react";
import { useNavigate } from "react-router-dom";
import solanaIcon from "../../../assets/solanaIcon.svg";
import styles from "./TrendingCollection.module.scss";

const TrendingCollection = ({ name, blockchain, img, price, percentage }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.container} onClick={() => navigate("/explore-collection")}>
      <div className={styles.imgContainer}>
        <img src={img} alt="collection-pic" />
      </div>
      <h5>{name}</h5>
      <div className={styles.price}>
        {blockchain === "SOL" ? <img src={solanaIcon} alt="solana" /> : null}
        <p>{price}</p>
      </div>
      <div className={styles.perc}>
        <p>{percentage}</p>
      </div>
    </div>
  );
};

export default TrendingCollection;
